import React from "react";
import { Quotes } from "@phosphor-icons/react";

const MENTOR_IMG = "/mentor-vishnu.webp";

export default function Mentor() {
  return (
    <section
      data-testid="mentor-section"
      id="mentor"
      className="py-20 lg:py-28 border-t border-[#D4D0C5] bg-[#EAE8DF]"
    >
      <div className="max-w-[1320px] mx-auto px-5 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
        <div className="lg:col-span-5">
          <div className="relative border border-[#0A0A0A]">
            <img
              src={MENTOR_IMG}
              alt="Vishnu Gupthan R"
              className="w-full aspect-[4/5] object-cover"
            />
            <div className="absolute -bottom-4 -right-4 bg-[#0A0A0A] text-[#F4F3ED] px-4 py-3 hidden sm:block">
              <div className="font-mono-acc text-[9px] tracking-[0.3em] text-[#A1A1AA]">
                SIGNATURE
              </div>
              <div className="font-display font-black text-lg leading-none">
                V. GUPTHAN
              </div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="font-mono-acc text-[10px] tracking-[0.3em] uppercase text-[#D9381E] mb-4">
            02 / THE MENTOR
          </div>
          <h2 className="font-display font-black text-4xl lg:text-6xl leading-[0.95] tracking-tighter">
            Mr. Vishnu
            <br />
            Gupthan R.
          </h2>
          <div className="skel-line my-7 bg-[#0A0A0A]/30" />

          <p className="font-body text-base lg:text-lg text-[#0A0A0A] leading-relaxed">
            An exclusive, high-impact learning experience designed for{" "}
            <span className="font-semibold">serious traders</span>. Gain deep
            insights into Market Profile, Order Flow and trading
            psychology—taught by a professional who trades the markets every
            single day.
          </p>

          <div className="mt-7 border-l-4 border-[#D9381E] pl-5">
            <Quotes size={22} weight="fill" className="text-[#D9381E] mb-2" />
            <p className="font-display text-xl lg:text-2xl tracking-tight leading-snug">
              "I don't teach prediction. I teach you how to listen to what the
              market is already telling you—through volume, value and
              footprint."
            </p>
          </div>

          <div className="grid grid-cols-3 gap-4 mt-10">
            <div className="border border-[#0A0A0A] p-4">
              <div className="font-mono-acc font-bold text-2xl">20+</div>
              <div className="font-mono-acc text-[10px] tracking-[0.2em] uppercase text-[#4A4A4A] leading-snug">
                Years Market<br />Experience
              </div>
            </div>
            <div className="border border-[#0A0A0A] p-4">
              <div className="font-mono-acc font-bold text-2xl">500+</div>
              <div className="font-mono-acc text-[10px] tracking-[0.2em] uppercase text-[#4A4A4A] leading-snug">
                Students<br />Trained
              </div>
            </div>
            <div className="border border-[#0A0A0A] p-4 bg-[#0A0A0A] text-[#F4F3ED]">
              <div className="font-mono-acc font-bold text-2xl text-[#D9381E]">
                10+
              </div>
              <div className="font-mono-acc text-[10px] tracking-[0.2em] uppercase text-[#A1A1AA] leading-snug">
                Years MP &<br />Order Flow
              </div>
            </div>
          </div>
          <div className="mt-4 font-mono-acc text-[10px] tracking-[0.3em] uppercase text-[#D9381E]">
            Building a community of system traders
          </div>
        </div>
      </div>
    </section>
  );
}
